import { useQuery } from "@tanstack/react-query";
import apiClient from "@apis/index";
import Routes from "@apis/routes";
import { TermsOfServiceResponse } from "@src/types/TermsOfService";

export const useTermsAndConditions = () => {
  return useQuery({
    queryKey: ["USER_TERMS_AND_CONDITIONS"],
    queryFn: () =>
      apiClient.get<TermsOfServiceResponse>(Routes.USER_TERMS_AND_CONDITIONS),
  });
};
